"use client";

import { withFallback } from "../with-fallback";

export const AvailableCashBreakdownElement = withFallback({
	displayName: "AvailableCashBreakdownElement",
	type: "available-cash-breakdown-element",
} as const);
